module.exports = __webpack_public_path__ + "img/select.9bcf65b8.svg";